module.exports = __webpack_public_path__ + "static/img/王玉芳.ecddf1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/王玉芳.jpg
// module id = plga
// module chunks = 139